// Hanya berjalan di PDP. Memposisikan nudge sejajar dengan tombol WA lewat CSS
// (injectShadowDOMStyle). PERBAIKAN: observer kini menembus shadow DOM —
// MutationObserver pada document.body TIDAK melihat perubahan di dalam shadow
// root, sedangkan nudge Shopify dirender di dalam shadow root (kadang baru
// muncul saat scroll, terutama di iPhone) sehingga sebelumnya tidak terdeteksi.
if (window.location.pathname.includes('/products/')) {
  const WA_BOTTOM = 85;     // harus SAMA dengan nilai bottom tombol WA di gently-v2.css

  let styleInjected = false;
  let nudgeEl = null;
  let listenersAttached = false;
  let rafId = null;

  // ---- Helper menembus nested Shadow DOM Shopify ----
  const getShopifyChat = () => document.querySelector('shopify-chat');
  const getRuntime = () => {
    const chat = getShopifyChat();
    return chat && chat.shadowRoot ? chat.shadowRoot.querySelector('shopify-agent-runtime') : null;
  };

  // Suntik CSS ke nested Shadow DOM Shopify Chat.
  const injectShadowDOMStyle = () => {
    const runtime = getRuntime();
    if (!runtime || !runtime.shadowRoot) return false;
    if (!styleInjected) {
      if (!runtime.shadowRoot.querySelector('#custom-chat-pos')) {
        const style = document.createElement('style');
        style.id = 'custom-chat-pos';
        style.textContent = `
          @media (max-width: 768px) {
            .activator-nudge.activator-nudge--right {
              position: fixed !important;
              top: auto !important;
              bottom: var(--wa-nudge-bottom, 85px) !important;
              right: 16px !important;
            }
          }
        `;
        runtime.shadowRoot.appendChild(style);
      }
      styleInjected = true;
    }
    nudgeEl = runtime.shadowRoot.querySelector('.activator-nudge.activator-nudge--right');
    return true;
  };

  // Hapus properti yang membuat ancestor jadi containing block untuk position:fixed.
  const killContainingBlock = (node) => {
    if (!node || node.nodeType !== 1) return;
    const cs = getComputedStyle(node);
    const b =
      (cs.transform && cs.transform !== 'none') ||
      (cs.perspective && cs.perspective !== 'none') ||
      (cs.filter && cs.filter !== 'none') ||
      (cs['backdrop-filter'] && cs['backdrop-filter'] !== 'none') ||
      (cs['will-change'] && cs['will-change'] !== 'auto' && /transform|perspective|filter/.test(cs['will-change'])) ||
      (cs.contain && cs.contain !== 'none' && /paint|layout|strict|content/.test(cs.contain));
    if (!b) return;
    node.style.setProperty('transform', 'none', 'important');
    node.style.setProperty('perspective', 'none', 'important');
    node.style.setProperty('filter', 'none', 'important');
    node.style.setProperty('backdrop-filter', 'none', 'important');
    node.style.setProperty('will-change', 'auto', 'important');
    node.style.setProperty('contain', 'none', 'important');
  };

  const neutralizeAncestors = (shopifyChat, runtime, nudge) => {
    killContainingBlock(shopifyChat);
    killContainingBlock(runtime);
    const root = nudge.getRootNode();
    let node = nudge.parentElement;
    while (node && node !== root.host) {
      killContainingBlock(node);
      node = node.parentElement;
    }
  };

  const computeOffset = () => {
    const waBtn = document.getElementById('wa-chat-btn-root');
    if (!waBtn || !nudgeEl) return;
    nudgeEl.style.setProperty('--wa-nudge-bottom', WA_BOTTOM + 'px');
  };

  const schedule = () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(computeOffset);
  };

  const attachListeners = () => {
    if (listenersAttached) return;
    listenersAttached = true;
    window.addEventListener('resize', schedule);
    window.addEventListener('orientationchange', schedule);
    window.addEventListener('load', schedule);
  };

  const trySetup = () => {
    const shopifyChat = getShopifyChat();
    const runtime = getRuntime();
    if (!shopifyChat || !runtime || !runtime.shadowRoot) return false;
    if (!injectShadowDOMStyle()) return false;
    if (!nudgeEl) return false;
    if (!document.getElementById('wa-chat-btn-root')) return false;
    const r = nudgeEl.getBoundingClientRect();
    if (!r.width && !r.height) return false; // nudge belum ter-layout, coba lagi nanti
    neutralizeAncestors(shopifyChat, runtime, nudgeEl);
    computeOffset();
    attachListeners();
    return true;
  };

  // ===== Observer: WAJIB menembus shadow DOM =====
  // Pasang observer di document.body DAN di tiap shadow root yang muncul
  // (shopify-chat -> shopify-agent-runtime), agar kemunculan nudge di dalam
  // shadow DOM tetap terdeteksi (kasus iPhone: nudge baru dirender saat scroll).
  const observers = [];
  const observedRoots = new Set();

  const onMutation = () => {
    observeShadowRoots();
    if (trySetup()) {
      observers.forEach((o) => o.disconnect());
      observers.length = 0;
    }
  };

  const observeRoot = (root) => {
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);
    observers.push(new MutationObserver(onMutation));
    observers[observers.length - 1].observe(root, { childList: true, subtree: true });
  };

  const observeShadowRoots = () => {
    const chat = getShopifyChat();
    if (chat && chat.shadowRoot) {
      observeRoot(chat.shadowRoot);
      const runtime = chat.shadowRoot.querySelector('shopify-agent-runtime');
      if (runtime && runtime.shadowRoot) observeRoot(runtime.shadowRoot);
    }
  };

  observeRoot(document.body);
  observeShadowRoots();
  onMutation();
}
